var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDixiLogoNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 289.6 168.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_61);}.cls-4{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_61-2);}.cls-5{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_35);}.cls-6{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_35-2);}.cls-7{fill:url(#linear-gradient);}.cls-8{fill:#776692;mix-blend-mode:multiply;}.cls-9{fill:#201d9f;}.cls-10{clip-path:url(#clip-path);}.cls-11{fill:#68b0ff;}.cls-12{fill:#67afff;}.cls-13{fill:#66aeff;}.cls-14{fill:#66adff;}.cls-15{fill:#65abff;}.cls-16{fill:#64aaff;}.cls-17{fill:#63a9ff;}.cls-18{fill:#62a8ff;}.cls-19{fill:#61a7ff;}.cls-20{fill:#61a6ff;}.cls-21{fill:#60a4ff;}.cls-22{fill:#5fa3ff;}.cls-23{fill:#5ea2ff;}.cls-24{fill:#5da1ff;}.cls-25{fill:#5ca0ff;}.cls-26{fill:#5c9fff;}.cls-27{fill:#5b9eff;}.cls-28{fill:#5a9cff;}.cls-29{fill:#599bff;}.cls-30{fill:#589aff;}.cls-31{fill:#5899ff;}.cls-32{fill:#5798ff;}.cls-33{fill:#5697ff;}.cls-34{fill:#5596ff;}.cls-35{fill:#5495ff;}.cls-36{fill:#5494ff;}.cls-37{fill:#5392ff;}.cls-38{fill:#5291ff;}.cls-39{fill:#5190ff;}.cls-40{fill:#518fff;}.cls-41{fill:#508eff;}.cls-42{fill:#4f8dff;}.cls-43{fill:#4e8cff;}.cls-44{fill:#4d8bff;}.cls-45{fill:#4d8aff;}.cls-46{fill:#4c89ff;}.cls-47{fill:#4b88ff;}.cls-48{fill:#4a86ff;}.cls-49{fill:#4a85ff;}.cls-50{fill:#4984ff;}.cls-51{fill:#4883ff;}.cls-52{fill:#4782ff;}.cls-53{fill:#4781ff;}.cls-54{fill:#4680ff;}.cls-55{fill:#457fff;}.cls-56{fill:#447eff;}.cls-57{fill:#447dff;}.cls-58{fill:#437cff;}.cls-59{fill:#427bff;}.cls-60{fill:#417aff;}.cls-61{fill:#4179ff;}.cls-62{fill:#4078ff;}.cls-63{fill:#3f77ff;}.cls-64{fill:#3f76ff;}.cls-65{fill:#3e75ff;}.cls-66{fill:#3d74ff;}.cls-67{fill:#3c73ff;}.cls-68{fill:#3c72ff;}.cls-69{fill:#3b71ff;}.cls-70{fill:#3a70ff;}.cls-71{fill:#3a6fff;}.cls-72{fill:#396eff;}.cls-73{fill:#386dff;}.cls-74{fill:#386cff;}.cls-75{fill:#376bff;}.cls-76{fill:#366aff;}.cls-77{fill:#3669ff;}.cls-78{fill:#3569ff;}.cls-79{fill:#3468ff;}.cls-80{fill:#3467ff;}.cls-81{fill:#36f;}.cls-82{fill:#3265ff;}.cls-83{fill:#3264ff;}.cls-84{fill:#3163ff;}.cls-85{fill:#3162ff;}.cls-86{fill:#3062ff;}.cls-87{fill:#2f61ff;}.cls-88{fill:#2f60ff;}.cls-89{fill:#2e5fff;}.cls-90{fill:#2d5eff;}.cls-91{fill:#2d5dff;}.cls-92{fill:#2c5dff;}.cls-93{fill:#2c5cff;}.cls-94{clip-path:url(#clip-path-2);}.cls-95{clip-path:url(#clip-path-3);}.cls-96{fill:#3b8bff;}.cls-97{fill:#3b8cff;}.cls-98{fill:#3a8dff;}.cls-99{fill:#3a8fff;}.cls-100{fill:#3a90ff;}.cls-101{fill:#3a91ff;}.cls-102{fill:#3992ff;}.cls-103{fill:#3993ff;}.cls-104{fill:#3994ff;}.cls-105{fill:#3895ff;}.cls-106{fill:#3897ff;}.cls-107{fill:#3898ff;}.cls-108{fill:#3899ff;}.cls-109{fill:#379aff;}.cls-110{fill:#379bff;}.cls-111{fill:#379cff;}.cls-112{fill:#379dff;}.cls-113{fill:#369eff;}.cls-114{fill:#36a0ff;}.cls-115{fill:#36a1ff;}.cls-116{fill:#35a2ff;}.cls-117{fill:#35a3ff;}.cls-118{fill:#35a4ff;}.cls-119{fill:#35a5ff;}.cls-120{fill:#34a6ff;}.cls-121{fill:#34a7ff;}.cls-122{fill:#34a8ff;}.cls-123{fill:#34a9ff;}.cls-124{fill:#33abff;}.cls-125{fill:#33acff;}.cls-126{fill:#33adff;}.cls-127{fill:#33aeff;}.cls-128{fill:#32afff;}.cls-129{fill:#32b0ff;}.cls-130{fill:#32b1ff;}.cls-131{fill:#32b2ff;}.cls-132{fill:#31b3ff;}.cls-133{fill:#31b4ff;}.cls-134{fill:#31b5ff;}.cls-135{fill:#31b6ff;}.cls-136{fill:#30b7ff;}.cls-137{fill:#30b8ff;}.cls-138{fill:#30b9ff;}.cls-139{fill:#30baff;}.cls-140{fill:#2fbbff;}.cls-141{fill:#2fbcff;}.cls-142{fill:#2fbdff;}.cls-143{fill:#2fbeff;}.cls-144{fill:#2fbfff;}.cls-145{fill:#2ec0ff;}.cls-146{fill:#2ec1ff;}.cls-147{fill:#2ec2ff;}.cls-148{fill:#2dc3ff;}.cls-149{fill:#2dc4ff;}.cls-150{fill:#2dc5ff;}.cls-151{fill:#2dc6ff;}.cls-152{fill:#2cc7ff;}.cls-153{fill:#2cc8ff;}.cls-154{fill:#2cc9ff;}.cls-155,.cls-156,.cls-158{fill:#a1ffff;}.cls-155{opacity:0.5;}.cls-157{fill:#a1c9ff;}.cls-158{mix-blend-mode:soft-light;}.cls-159{mix-blend-mode:screen;fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_77);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_61",
    x1: 341.87,
    y1: 253.1,
    x2: 341.87,
    y2: 129.85,
    gradientTransform: "matrix(1, -0.09, 0.1, 1.05, -16.62, 33.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68b0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#688aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#6740ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#6612ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#60f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#5500dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4400b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#37009b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2f008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c0085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_61-2",
    x1: 533.55,
    y1: 253.1,
    x2: 533.55,
    y2: 129.84,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_61"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_35",
    cx: 439.6,
    cy: 191.48,
    r: 65.53,
    gradientTransform: "matrix(1, -0.09, 0.1, 1.05, -16.62, 33.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c5cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#396fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#5ca0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68b0ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_35-2",
    cx: 200.34,
    cy: 191.09,
    r: 65.73,
    gradientTransform: "matrix(-1, 0.09, 0.1, 1.05, 622.79, -23.93)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 297.58,
    y1: 204.24,
    x2: 587.18,
    y2: 204.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2ac4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#35b8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#529ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#747676"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-297.58 -111.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503.06,124.6s34.6-5.34,67.79,28.24c0,0-20.87-25.52-65.78-23.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-297.58 -111.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.75,176.87s19.53-34.14,57.95-39.69l-.83,5.36S330.68,143.14,306.75,176.87Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-297.58 -111.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.43,227.51l17.76-17.46,33-41.61,6.34,3.28S413.7,211.58,400.21,225Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_77",
    cx: 435.28,
    cy: 206.35,
    r: 55.61,
    gradientTransform: "translate(-16.2 40.61) rotate(-5.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4c5cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3541b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#222a73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#141842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#090b1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#020308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M377.09,267c-33.84,3.08-64-23.55-67.28-59.37a66.79,66.79,0,0,1,13.57-47.27,59.69,59.69,0,0,1,41-23.17l.89-.09c1.21-.11,2.34-.18,3.45-.21l1.11,31.9c-.51,0-1.06.05-1.67.11l-.39,0c-17,1.76-29.56,17.9-27.92,36,1.66,18.28,17.07,31.88,34.34,30.31l.8-.09.36,0L377,252.82l1.52,14.05h-.07Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M547.46,140.1a59.7,59.7,0,0,0-44.4-15.5,56.55,56.55,0,0,0-10.19,1.64,14.33,14.33,0,0,0-1.69.52l10.25,30.12a13.73,13.73,0,0,1-3.6.81l1.16-.1,1.13-.29a30,30,0,0,1,4.72-.82l.4,0h.15c17-1.24,32.16,12.37,33.8,30.35,1.66,18.28-11,34.43-28.32,36l2.89,31.79c33.85-3.08,58.73-34.72,55.47-70.53A66.88,66.88,0,0,0,547.46,140.1Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M451.94,185.18c-26.37-25.1-53.64-51.05-87.24-48l2.89,31.8c20.49-1.87,42.75,19.32,64.28,39.81,25.11,23.9,51.07,48.6,81.89,45.8l-2.26-31.86C493.79,224.34,472.21,204.46,451.94,185.18Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M378.24,266.9l-2.89-31.79c12.68-1.15,32.82-26.57,49-47C449,157,474.51,124.77,505,124.47l.6,31.91c-16.64.17-38.62,27.9-58,52.37C424.81,237.48,403.31,264.62,378.24,266.9Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M562.89,144.91a68.22,68.22,0,0,0-47.23-16.19v-.05a53.72,53.72,0,0,0-12.88,1.81l-.6.13a17.75,17.75,0,0,0-1.89.55v0c-21.64,6.72-41.2,26-60,47.59-23.22-19.93-47.72-37-76.44-36.18v-.05c-1.25,0-2.5.11-3.85.24l-1,.1a68.66,68.66,0,0,0,13.43,136.65l1.5-.16h.09v0c24.55-3.11,47.37-26.31,69.65-52.59,24.8,21.88,50.75,41.69,81,38.93v0a68.66,68.66,0,0,0,38.15-120.77Zm-192.19,101h0l-.4,0-.88.09a35,35,0,0,1-6.93-69.75c18-1.6,37.11,11.84,56.08,28.11C401.91,224.06,383.07,244.8,370.7,245.93Zm151.54-13.78c-17,1.44-37.17-13.88-56.79-31.07,15.5-17.79,31.47-33.92,45-37.87a34,34,0,0,1,4.91-.81l.45,0H516a35,35,0,0,1,6.29,69.8Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "146.13 115.41 169.51 87.87 172.76 92.4 156.33 124.18 146.13 115.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "176.53 80.38 176.03 80.33 178.42 56.03 150.85 58.53 144.65 54.78 144.91 54.35 150.97 58.02 178.97 55.47 176.53 80.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "273.47 92.55 273.31 92.46 255.79 83.04 241.36 84.3 241.31 83.8 255.9 82.53 273.38 91.94 288.83 76.83 289.19 77.18 273.47 92.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "176.82 139.71 168.37 116.25 168.57 116.15 188.07 106.2 187.73 102.44 188.23 102.39 188.6 106.49 168.99 116.49 177.29 139.54 176.82 139.71"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 205.48,
    y: 7.92,
    width: 67.8,
    height: 33.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M511.09,141.06c-1.37-15.11,9.09-28.42,23.37-29.72v6.92h19v-.57A28.62,28.62,0,0,1,557,156.4v-2.56H520.43v5.89A28.21,28.21,0,0,1,511.09,141.06Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M511.4,141c-1.36-14.94,9-28.09,23.09-29.37v6.59h18.79v-.32a28.28,28.28,0,0,1,3.48,38.25v-2.35H520.62v5.64A27.91,27.91,0,0,1,511.4,141Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M511.71,141c-1.35-14.76,8.87-27.75,22.81-29v6.27h18.57v-.07A28,28,0,0,1,556.52,156v-2.14h-35.7v5.39A27.53,27.53,0,0,1,511.71,141Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M512,141c-1.32-14.58,8.77-27.41,22.54-28.66a24.3,24.3,0,0,1,18.34,6.12,27.63,27.63,0,0,1,3.4,37.33v-1.93H521V159A27.25,27.25,0,0,1,512,141Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M512.32,141c-1.31-14.4,8.66-27.07,22.26-28.31s25.7,9.43,27,23.83a26.89,26.89,0,0,1-5.54,19.09v-1.72H521.21v4.89A26.93,26.93,0,0,1,512.32,141Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M512.63,140.92c-1.29-14.21,8.55-26.73,22-27.95s25.37,9.31,26.67,23.53a26.56,26.56,0,0,1-5.47,18.85v-1.51h-34.4v4.64A26.55,26.55,0,0,1,512.63,140.92Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M512.94,140.9c-1.28-14,8.44-26.4,21.7-27.6s25.05,9.19,26.33,23.23a26.19,26.19,0,0,1-5.4,18.61v-1.3h-34v4.39A26.22,26.22,0,0,1,512.94,140.9Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M513.25,140.87c-1.26-13.86,8.33-26.06,21.42-27.25s24.73,9.08,26,22.93a25.87,25.87,0,0,1-5.33,18.38v-1.09H521.8V158A25.87,25.87,0,0,1,513.25,140.87Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M513.55,140.84c-1.24-13.68,8.23-25.72,21.15-26.89s24.41,9,25.65,22.63a25.5,25.5,0,0,1-5.26,18.14v-.88H522v3.89A25.59,25.59,0,0,1,513.55,140.84Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M513.86,140.81c-1.23-13.5,8.12-25.38,20.87-26.54s24.09,8.84,25.32,22.34a25.22,25.22,0,0,1-5.2,17.9v-.67H522.2v3.64A25.22,25.22,0,0,1,513.86,140.81Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M514.17,140.78c-1.21-13.31,8-25,20.59-26.18s23.77,8.72,25,22a24.92,24.92,0,0,1-5.12,17.66v-.46H522.39v3.39A24.85,24.85,0,0,1,514.17,140.78Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M514.48,140.76c-1.2-13.14,7.9-24.71,20.31-25.84s23.45,8.61,24.64,21.75a24.55,24.55,0,0,1-5,17.42v-.25H522.59V157A24.51,24.51,0,0,1,514.48,140.76Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M514.78,140.73c-1.17-13,7.8-24.37,20-25.48s23.12,8.49,24.3,21.44a24.21,24.21,0,0,1-5,17.18v0H522.79v2.89A24.19,24.19,0,0,1,514.78,140.73Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M515.09,140.7c-1.16-12.78,7.69-24,19.76-25.12s22.8,8.37,24,21.14a23.82,23.82,0,0,1-4.91,16.94,21.77,21.77,0,0,1-6.5,5.59v-5.41H523v2.64A23.89,23.89,0,0,1,515.09,140.7Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M515.4,140.67c-1.15-12.6,7.58-23.69,19.48-24.77s22.48,8.25,23.63,20.85a23.5,23.5,0,0,1-4.85,16.7,21.45,21.45,0,0,1-6.41,5.51v-5.12H523.18v2.39A23.51,23.51,0,0,1,515.4,140.67Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M515.71,140.64c-1.13-12.41,7.47-23.34,19.2-24.41s22.16,8.13,23.29,20.55a23.17,23.17,0,0,1-4.78,16.46,21.37,21.37,0,0,1-6.31,5.44v-4.84H523.38V156A23.16,23.16,0,0,1,515.71,140.64Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M516,140.62c-1.12-12.24,7.36-23,18.92-24.07s21.84,8,22.95,20.26A22.78,22.78,0,0,1,553.18,153a21,21,0,0,1-6.22,5.36v-4.55H523.57v1.89A22.86,22.86,0,0,1,516,140.62Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M516.32,140.59c-1.09-12.06,7.25-22.67,18.65-23.71s21.52,7.9,22.61,20-7.25,22.68-18.64,23.71v-6.7H523.77v1.63A22.51,22.51,0,0,1,516.32,140.59Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M516.63,140.56c-1.08-11.88,7.14-22.33,18.37-23.35s21.19,7.78,22.27,19.65-7.14,22.34-18.36,23.36v-6.38H524v1.38A22.15,22.15,0,0,1,516.63,140.56Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M516.94,140.53c-1.06-11.7,7-22,18.09-23s20.87,7.66,21.94,19.36-7,22-18.09,23v-6H524.16V155A21.81,21.81,0,0,1,516.94,140.53Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 536.95,
    cy: 138.71,
    rx: 19.79,
    ry: 20.94,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 536.95,
    cy: 138.71,
    rx: 19.48,
    ry: 20.61,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 536.95,
    cy: 138.71,
    rx: 19.17,
    ry: 20.29,
    transform: "translate(-307.94 -62.12) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 536.95,
    cy: 138.71,
    rx: 18.86,
    ry: 19.96,
    transform: "translate(-307.93 -62.13) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 536.95,
    cy: 138.71,
    rx: 18.55,
    ry: 19.63,
    transform: "translate(-307.93 -62.15) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 536.95,
    cy: 138.71,
    rx: 18.24,
    ry: 19.3,
    transform: "translate(-307.94 -62.11) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 536.95,
    cy: 138.71,
    rx: 17.93,
    ry: 18.98,
    transform: "translate(-307.93 -62.13) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M519.4,140.31c-.93-10.26,6.17-19.29,15.86-20.17s18.31,6.72,19.24,17-6.16,19.29-15.86,20.17S520.34,150.56,519.4,140.31Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 536.95,
    cy: 138.71,
    rx: 17.31,
    ry: 18.32,
    transform: "translate(-307.94 -62.12) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 536.95,
    cy: 138.71,
    rx: 17,
    ry: 18,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 536.95,
    cy: 138.71,
    rx: 16.7,
    ry: 17.67,
    transform: "translate(-307.93 -62.15) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 536.95,
    cy: 138.71,
    rx: 16.39,
    ry: 17.34,
    transform: "translate(-307.94 -62.12) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 536.95,
    cy: 138.71,
    rx: 16.08,
    ry: 17.01,
    transform: "translate(-307.93 -62.13) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-44",
    cx: 536.95,
    cy: 138.71,
    rx: 15.77,
    ry: 16.69,
    transform: "translate(-307.93 -62.16) rotate(-5.19)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-45",
    cx: 536.95,
    cy: 138.71,
    rx: 15.46,
    ry: 16.36,
    transform: "translate(-307.94 -62.12) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-46",
    cx: 536.95,
    cy: 138.71,
    rx: 15.15,
    ry: 16.03,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M522.17,140.06c-.78-8.64,5.2-16.25,13.36-17s15.42,5.66,16.2,14.3-5.19,16.24-13.35,17S523,148.69,522.17,140.06Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-48",
    cx: 536.95,
    cy: 138.71,
    rx: 14.53,
    ry: 15.38,
    transform: "translate(-307.94 -62.13) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 536.95,
    cy: 138.71,
    rx: 14.22,
    ry: 15.05,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M523.1,140c-.74-8.1,4.87-15.23,12.52-15.92s14.45,5.3,15.19,13.4-4.87,15.23-12.52,15.92S523.83,148.07,523.1,140Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-51",
    cx: 536.95,
    cy: 138.71,
    rx: 13.6,
    ry: 14.4,
    transform: "translate(-307.94 -62.12) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-52",
    cx: 536.95,
    cy: 138.71,
    rx: 13.29,
    ry: 14.07,
    transform: "translate(-307.93 -62.15) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 536.95,
    cy: 138.71,
    rx: 12.99,
    ry: 13.74,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M524.33,139.86c-.67-7.38,4.44-13.87,11.41-14.51s13.17,4.83,13.84,12.21-4.44,13.88-11.41,14.51S525,147.24,524.33,139.86Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-55",
    cx: 536.95,
    cy: 138.71,
    rx: 12.37,
    ry: 13.09,
    transform: "translate(-307.94 -62.12) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 536.95,
    cy: 138.71,
    rx: 12.06,
    ry: 12.76,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-57",
    cx: 536.95,
    cy: 138.71,
    rx: 11.75,
    ry: 12.43,
    transform: "translate(-307.93 -62.13) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-58",
    cx: 536.95,
    cy: 138.71,
    rx: 11.44,
    ry: 12.11,
    transform: "translate(-307.94 -62.12) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M525.87,139.72c-.59-6.48,3.89-12.18,10-12.74s11.56,4.24,12.15,10.72-3.9,12.18-10,12.74S526.46,146.2,525.87,139.72Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-60",
    cx: 536.95,
    cy: 138.71,
    rx: 10.82,
    ry: 11.45,
    transform: "translate(-307.94 -62.12) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-61",
    cx: 536.95,
    cy: 138.71,
    rx: 10.51,
    ry: 11.12,
    transform: "translate(-307.93 -62.13) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-62",
    cx: 536.95,
    cy: 138.71,
    rx: 10.2,
    ry: 10.8,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-63",
    cx: 536.95,
    cy: 138.71,
    rx: 9.89,
    ry: 10.47,
    transform: "translate(-307.93 -62.13) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-64",
    cx: 536.95,
    cy: 138.71,
    rx: 9.58,
    ry: 10.14,
    transform: "translate(-307.94 -62.12) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-65",
    cx: 536.95,
    cy: 138.71,
    rx: 9.28,
    ry: 9.82,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M528,139.52a9,9,0,1,1,9.79,8.64A9.24,9.24,0,0,1,528,139.52Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-67",
    cx: 536.95,
    cy: 138.71,
    rx: 8.66,
    ry: 9.16,
    transform: "translate(-307.94 -62.11) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M528.64,139.47a8.36,8.36,0,1,1,9.11,8A8.61,8.61,0,0,1,528.64,139.47Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-69",
    cx: 536.95,
    cy: 138.71,
    rx: 8.04,
    ry: 8.51,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-70",
    cx: 536.95,
    cy: 138.71,
    rx: 7.73,
    ry: 8.18,
    transform: "translate(-307.94 -62.12) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M529.56,139.38a7.43,7.43,0,1,1,8.1,7.15A7.65,7.65,0,0,1,529.56,139.38Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-72",
    cx: 536.95,
    cy: 138.71,
    rx: 7.11,
    ry: 7.53,
    transform: "translate(-307.93 -62.14) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-73",
    cx: 536.95,
    cy: 138.71,
    rx: 6.8,
    ry: 7.2,
    transform: "matrix(1, -0.09, 0.09, 1, -307.93, -62.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M530.49,139.3a6.5,6.5,0,1,1,7.09,6.25A6.68,6.68,0,0,1,530.49,139.3Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M530.8,139.27a6.19,6.19,0,1,1,6.75,6A6.37,6.37,0,0,1,530.8,139.27Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M531.1,139.24a5.88,5.88,0,1,1,6.42,5.66A6.05,6.05,0,0,1,531.1,139.24Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M531.41,139.22a5.58,5.58,0,1,1,6.08,5.36A5.73,5.73,0,0,1,531.41,139.22Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M531.72,139.19a5.27,5.27,0,1,1,5.74,5.06A5.42,5.42,0,0,1,531.72,139.19Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M532,139.16a5,5,0,1,1,5.4,4.76A5.09,5.09,0,0,1,532,139.16Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M532.34,139.13a4.64,4.64,0,1,1,5.06,4.47A4.78,4.78,0,0,1,532.34,139.13Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M532.64,139.1a4.33,4.33,0,1,1,4.73,4.17A4.46,4.46,0,0,1,532.64,139.1Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-82",
    cx: 536.95,
    cy: 138.71,
    rx: 4.02,
    ry: 4.25,
    transform: "translate(-307.94 -62.08) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M533.26,139.05a3.72,3.72,0,1,1,4,3.57A3.83,3.83,0,0,1,533.26,139.05Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M533.57,139a3.41,3.41,0,1,1,3.71,3.28A3.5,3.5,0,0,1,533.57,139Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M533.87,139a3.1,3.1,0,1,1,3.38,3A3.2,3.2,0,0,1,533.87,139Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M534.18,139a2.79,2.79,0,1,1,3,2.68A2.87,2.87,0,0,1,534.18,139Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M534.49,138.94a2.48,2.48,0,1,1,2.7,2.38A2.56,2.56,0,0,1,534.49,138.94Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M534.8,138.91a2.17,2.17,0,1,1,2.36,2.08A2.23,2.23,0,0,1,534.8,138.91Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M535.11,138.88a1.86,1.86,0,1,1,2,1.79A1.91,1.91,0,0,1,535.11,138.88Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M535.41,138.85a1.6,1.6,0,0,1,1.4-1.77,1.64,1.64,0,1,1-1.4,1.77Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M535.72,138.82a1.24,1.24,0,1,1,1.35,1.19A1.27,1.27,0,0,1,535.72,138.82Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M536,138.8a1,1,0,0,1,.83-1.07,1,1,0,0,1,1,.9.93.93,0,1,1-1.85.17Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M536.34,138.77a.64.64,0,0,1,.55-.71.65.65,0,0,1,.12,1.3A.63.63,0,0,1,536.34,138.77Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M536.65,138.74a.3.3,0,0,1,.27-.35.31.31,0,0,1,.34.29.33.33,0,0,1-.28.36A.31.31,0,0,1,536.65,138.74Z",
    transform: "translate(-297.58 -111.34)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 9.17,
    y: 25.84,
    width: 57.95,
    height: 39.68
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 335.72,
    cy: 157.03,
    rx: 24.83,
    ry: 26.28,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 335.72,
    cy: 157.03,
    rx: 24.54,
    ry: 25.97,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 335.72,
    cy: 157.03,
    rx: 24.24,
    ry: 25.65,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 335.72,
    cy: 157.03,
    rx: 23.95,
    ry: 25.34,
    transform: "translate(-310.42 -80.3) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 335.72,
    cy: 157.03,
    rx: 23.65,
    ry: 25.03,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 335.72,
    cy: 157.03,
    rx: 23.35,
    ry: 24.72,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 335.72,
    cy: 157.02,
    rx: 23.06,
    ry: 24.4,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 335.72,
    cy: 157.03,
    rx: 22.76,
    ry: 24.09,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 335.72,
    cy: 157.03,
    rx: 22.47,
    ry: 23.78,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 335.72,
    cy: 157.03,
    rx: 22.17,
    ry: 23.46,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 335.72,
    cy: 157.03,
    rx: 21.88,
    ry: 23.15,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 335.72,
    cy: 157.03,
    rx: 21.58,
    ry: 22.84,
    transform: "matrix(1, -0.09, 0.09, 1, -310.42, -80.28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 335.72,
    cy: 157.03,
    rx: 21.28,
    ry: 22.53,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 335.72,
    cy: 157.03,
    rx: 20.99,
    ry: 22.21,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 335.72,
    cy: 157.03,
    rx: 20.69,
    ry: 21.9,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 335.72,
    cy: 157.02,
    rx: 20.4,
    ry: 21.59,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 335.72,
    cy: 157.03,
    rx: 20.1,
    ry: 21.27,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 335.72,
    cy: 157.03,
    rx: 19.81,
    ry: 20.96,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M316.29,158.79c-1-11.35,6.83-21.35,17.56-22.33s20.27,7.44,21.3,18.8-6.82,21.35-17.56,22.33S317.33,170.15,316.29,158.79Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 335.72,
    cy: 157.03,
    rx: 19.22,
    ry: 20.34,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 335.72,
    cy: 157.03,
    rx: 18.92,
    ry: 20.02,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M317.18,158.71c-1-10.84,6.51-20.38,16.76-21.31s19.35,7.1,20.33,17.94-6.52,20.38-16.76,21.31S318.16,169.55,317.18,158.71Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 335.72,
    cy: 157.03,
    rx: 18.33,
    ry: 19.4,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 335.72,
    cy: 157.03,
    rx: 18.03,
    ry: 19.08,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 335.72,
    cy: 157.03,
    rx: 17.74,
    ry: 18.77,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 335.72,
    cy: 157.03,
    rx: 17.44,
    ry: 18.46,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 335.72,
    cy: 157.03,
    rx: 17.15,
    ry: 18.15,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-38",
    cx: 335.72,
    cy: 157.03,
    rx: 16.85,
    ry: 17.83,
    transform: "translate(-310.42 -80.27) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 335.72,
    cy: 157.03,
    rx: 16.56,
    ry: 17.52,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 335.72,
    cy: 157.03,
    rx: 16.26,
    ry: 17.21,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 335.72,
    cy: 157.03,
    rx: 15.96,
    ry: 16.89,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 335.72,
    cy: 157.03,
    rx: 15.67,
    ry: 16.58,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M320.41,158.42c-.81-8.95,5.39-16.83,13.84-17.6s16,5.86,16.78,14.81-5.38,16.83-13.83,17.6S321.23,167.37,320.41,158.42Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M320.71,158.39c-.8-8.78,5.28-16.5,13.57-17.25s15.66,5.74,16.46,14.52-5.28,16.5-13.57,17.25S321.51,167.17,320.71,158.39Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M321,158.36c-.78-8.6,5.18-16.17,13.31-16.91s15.35,5.63,16.13,14.24-5.17,16.17-13.3,16.91S321.79,167,321,158.36Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M321.3,158.34c-.77-8.43,5.07-15.86,13-16.58s15,5.52,15.81,14-5.07,15.86-13,16.58S322.06,166.77,321.3,158.34Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-47",
    cx: 335.72,
    cy: 157.03,
    rx: 14.19,
    ry: 15.02,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-48",
    cx: 335.72,
    cy: 157.03,
    rx: 13.89,
    ry: 14.7,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M322.18,158.26c-.72-7.92,4.76-14.89,12.24-15.57s14.13,5.19,14.85,13.1-4.76,14.89-12.24,15.57S322.9,166.17,322.18,158.26Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M322.48,158.23c-.71-7.74,4.65-14.56,12-15.23s13.82,5.08,14.52,12.82-4.65,14.56-12,15.23S323.18,166,322.48,158.23Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M322.77,158.2c-.69-7.57,4.55-14.23,11.71-14.88s13.51,5,14.2,12.53-4.56,14.23-11.71,14.88S323.46,165.77,322.77,158.2Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-52",
    cx: 335.72,
    cy: 157.03,
    rx: 12.71,
    ry: 13.45,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M323.36,158.15c-.66-7.23,4.34-13.59,11.17-14.21s12.9,4.73,13.56,12-4.35,13.59-11.18,14.21S324,165.38,323.36,158.15Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M323.65,158.12c-.64-7.05,4.25-13.26,10.91-13.87s12.59,4.62,13.23,11.68-4.24,13.26-10.9,13.87S324.29,165.18,323.65,158.12Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-55",
    cx: 335.72,
    cy: 157.03,
    rx: 11.83,
    ry: 12.51,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M324.24,158.07c-.61-6.71,4-12.62,10.38-13.2s12,4.4,12.59,11.11-4,12.62-10.38,13.2S324.85,164.78,324.24,158.07Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-57",
    cx: 335.72,
    cy: 157.03,
    rx: 11.23,
    ry: 11.89,
    transform: "translate(-310.42 -80.3) rotate(-5.19)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-58",
    cx: 335.72,
    cy: 157.03,
    rx: 10.94,
    ry: 11.58,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M325.12,158c-.56-6.2,3.73-11.65,9.58-12.18s11.06,4.06,11.62,10.25-3.72,11.65-9.58,12.18S325.69,164.18,325.12,158Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-60",
    cx: 335.72,
    cy: 157.03,
    rx: 10.35,
    ry: 10.95,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M325.71,157.94c-.53-5.86,3.52-11,9.05-11.51s10.44,3.83,11,9.68-3.51,11-9,11.51S326.25,163.79,325.71,157.94Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-62",
    cx: 335.72,
    cy: 157.03,
    rx: 9.76,
    ry: 10.32,
    transform: "translate(-310.41 -80.3) rotate(-5.19)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-63",
    cx: 335.72,
    cy: 157.03,
    rx: 9.46,
    ry: 10.01,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M326.6,157.86a9.18,9.18,0,1,1,10,8.82A9.43,9.43,0,0,1,326.6,157.86Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-65",
    cx: 335.72,
    cy: 157.03,
    rx: 8.87,
    ry: 9.39,
    transform: "translate(-310.42 -80.29) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M327.19,157.8a8.58,8.58,0,1,1,9.36,8.26A8.83,8.83,0,0,1,327.19,157.8Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M327.48,157.77a8.29,8.29,0,1,1,9,8A8.53,8.53,0,0,1,327.48,157.77Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M327.77,157.75a8,8,0,1,1,8.72,7.69A8.23,8.23,0,0,1,327.77,157.75Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M328.07,157.72a7.7,7.7,0,1,1,8.39,7.41A7.93,7.93,0,0,1,328.07,157.72Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-70",
    cx: 335.72,
    cy: 157.03,
    rx: 7.39,
    ry: 7.82,
    transform: "translate(-310.41 -80.3) rotate(-5.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M328.66,157.67a7.11,7.11,0,1,1,7.74,6.83A7.3,7.3,0,0,1,328.66,157.67Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M329,157.64a6.81,6.81,0,1,1,7.43,6.55A7,7,0,0,1,329,157.64Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M329.25,157.61a6.51,6.51,0,1,1,7.1,6.27A6.7,6.7,0,0,1,329.25,157.61Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-74",
    cx: 335.72,
    cy: 157.03,
    rx: 6.21,
    ry: 6.57,
    transform: "translate(-310.42 -80.28) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M329.84,157.56a5.92,5.92,0,1,1,6.45,5.7A6.09,6.09,0,0,1,329.84,157.56Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M330.13,157.53a5.63,5.63,0,1,1,6.13,5.41A5.78,5.78,0,0,1,330.13,157.53Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M330.42,157.51a5.33,5.33,0,1,1,5.81,5.12A5.48,5.48,0,0,1,330.42,157.51Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M330.72,157.48a5,5,0,1,1,5.49,4.84A5.18,5.18,0,0,1,330.72,157.48Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M331,157.45a4.74,4.74,0,1,1,5.17,4.56A4.88,4.88,0,0,1,331,157.45Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M331.31,157.43a4.44,4.44,0,1,1,4.84,4.27A4.57,4.57,0,0,1,331.31,157.43Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M331.6,157.4a4.15,4.15,0,1,1,4.52,4A4.27,4.27,0,0,1,331.6,157.4Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M331.9,157.37a3.85,3.85,0,1,1,4.19,3.71A4,4,0,0,1,331.9,157.37Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M332.19,157.35a3.56,3.56,0,1,1,3.87,3.41A3.65,3.65,0,0,1,332.19,157.35Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M332.49,157.32a3.25,3.25,0,1,1,3.55,3.13A3.34,3.34,0,0,1,332.49,157.32Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M332.78,157.29a3,3,0,1,1,3.23,2.85A3,3,0,0,1,332.78,157.29Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M333.07,157.27a2.67,2.67,0,1,1,2.91,2.56A2.75,2.75,0,0,1,333.07,157.27Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M333.37,157.24a2.37,2.37,0,1,1,2.58,2.28A2.44,2.44,0,0,1,333.37,157.24Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M333.66,157.21a2.07,2.07,0,1,1,2.26,2A2.14,2.14,0,0,1,333.66,157.21Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M334,157.19a1.78,1.78,0,1,1,1.93,1.7A1.81,1.81,0,0,1,334,157.19Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M334.25,157.16a1.48,1.48,0,1,1,1.62,1.42A1.52,1.52,0,0,1,334.25,157.16Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M334.55,157.13a1.18,1.18,0,1,1,1.29,1.14A1.21,1.21,0,0,1,334.55,157.13Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M334.84,157.11a.89.89,0,1,1,1,.85A.91.91,0,0,1,334.84,157.11Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M335.14,157.08a.6.6,0,0,1,.53-.68.63.63,0,1,1-.53.68Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M335.43,157.05a.3.3,0,0,1,.27-.34.32.32,0,0,1,.32.29.32.32,0,0,1-.27.34A.31.31,0,0,1,335.43,157.05Z",
    transform: "translate(-297.58 -111.34)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 91.86,
    y: 57.1,
    width: 57.13,
    height: 59.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M388.43,209V186.55h-2.62a28.25,28.25,0,0,1,19.68-10.85c16-1.46,30.24,11.1,31.78,28a31.63,31.63,0,0,1-6.52,22.46,28.89,28.89,0,0,1-8.62,7.41v-5.1H389.76v1.42a31,31,0,0,1-7.1-9.18h5.77Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M388.43,209v-22.1h-2.26a27.83,27.83,0,0,1,19.37-10.68c15.75-1.43,29.74,10.92,31.26,27.59a31.12,31.12,0,0,1-6.41,22.1,28.67,28.67,0,0,1-8.48,7.3v-4.67H390.06v1a30.54,30.54,0,0,1-7-9h5.36Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M388.43,208.93V187.19h-1.89a27.26,27.26,0,0,1,19-10.5c15.49-1.41,29.26,10.74,30.75,27.13a30.61,30.61,0,0,1-6.3,21.74,28.28,28.28,0,0,1-8.34,7.18v-4.23H390.35v.66a30.14,30.14,0,0,1-6.87-8.89h4.95Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M388.43,208.88V187.51H386.9a26.89,26.89,0,0,1,18.73-10.33c15.23-1.38,28.77,10.56,30.24,26.69a30.1,30.1,0,0,1-6.21,21.37,27.63,27.63,0,0,1-8.2,7.06v-3.79H390.65v.28a29.42,29.42,0,0,1-6.75-8.74h4.53Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M388.43,208.84v-21h-1.17a26.42,26.42,0,0,1,18.41-10.15c15-1.36,28.29,10.38,29.73,26.23s-9.53,29.8-24.51,31.16v-6.56H400.13v5.27a27.33,27.33,0,0,1-9.18-5.37,28.85,28.85,0,0,1-6.64-8.59h4.12Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M388.43,208.8V188.15h-.81a26,26,0,0,1,18.1-10c14.71-1.34,27.79,10.21,29.21,25.78s-9.37,29.29-24.08,30.63a26,26,0,0,1-19.6-6.55,29.05,29.05,0,0,1-9.62-19.23Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M388.43,208.76V188.47H388a25.44,25.44,0,0,1,17.77-9.8c14.46-1.32,27.31,10,28.7,25.32s-9.2,28.78-23.66,30.09-27.31-10-28.7-25.32Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M388.43,208.71V188.79h-.08a25,25,0,0,1,17.46-9.63C420,177.87,432.63,189,434,204s-9,28.26-23.24,29.55-26.83-9.85-28.19-24.88Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-104",
    cx: 408.28,
    cy: 206.37,
    rx: 25.35,
    ry: 26.83,
    transform: "translate(-314.59 -73.5) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-105",
    cx: 408.28,
    cy: 206.37,
    rx: 24.88,
    ry: 26.33,
    transform: "translate(-314.59 -73.52) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 408.28,
    cy: 206.38,
    rx: 24.41,
    ry: 25.83,
    transform: "translate(-314.59 -73.52) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-107",
    cx: 408.28,
    cy: 206.38,
    rx: 23.94,
    ry: 25.34,
    transform: "translate(-314.59 -73.52) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-108",
    cx: 408.28,
    cy: 206.37,
    rx: 23.47,
    ry: 24.84,
    transform: "translate(-314.59 -73.51) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M385.37,208.46c-1.22-13.39,8.05-25.18,20.71-26.33s23.89,8.77,25.11,22.16-8.05,25.18-20.7,26.33S386.59,221.85,385.37,208.46Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-110",
    cx: 408.28,
    cy: 206.37,
    rx: 22.53,
    ry: 23.85,
    transform: "matrix(1, -0.09, 0.09, 1, -314.6, -73.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-111",
    cx: 408.28,
    cy: 206.37,
    rx: 22.06,
    ry: 23.35,
    transform: "translate(-314.59 -73.52) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-112",
    cx: 408.28,
    cy: 206.37,
    rx: 21.6,
    ry: 22.85,
    transform: "translate(-314.59 -73.51) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-113",
    cx: 408.28,
    cy: 206.37,
    rx: 21.13,
    ry: 22.36,
    transform: "translate(-314.59 -73.51) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-114",
    cx: 408.28,
    cy: 206.38,
    rx: 20.66,
    ry: 21.86,
    transform: "translate(-314.59 -73.51) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-115",
    cx: 408.28,
    cy: 206.38,
    rx: 20.19,
    ry: 21.36,
    transform: "translate(-314.59 -73.51) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-116",
    cx: 408.28,
    cy: 206.38,
    rx: 19.72,
    ry: 20.87,
    transform: "matrix(1, -0.09, 0.09, 1, -314.59, -73.51)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-117",
    cx: 408.28,
    cy: 206.37,
    rx: 19.25,
    ry: 20.37,
    transform: "translate(-314.59 -73.5) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M389.58,208.08c-1-10.93,6.57-20.56,16.9-21.5S426,193.74,427,204.67s-6.57,20.56-16.9,21.5S390.57,219,389.58,208.08Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-119",
    cx: 408.28,
    cy: 206.38,
    rx: 18.31,
    ry: 19.38,
    transform: "translate(-314.59 -73.52) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M390.51,208c-.94-10.38,6.25-19.52,16.06-20.42s18.53,6.81,19.48,17.19S419.8,224.28,410,225.18,391.46,218.37,390.51,208Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M391,208c-.92-10.11,6.08-19,15.64-19.88s18,6.62,19,16.73-6.08,19-15.63,19.88S391.9,218.06,391,208Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-122",
    cx: 408.28,
    cy: 206.38,
    rx: 16.9,
    ry: 17.89,
    transform: "translate(-314.6 -73.49) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-123",
    cx: 408.28,
    cy: 206.38,
    rx: 16.43,
    ry: 17.39,
    transform: "matrix(1, -0.09, 0.09, 1, -314.6, -73.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-124",
    cx: 408.28,
    cy: 206.37,
    rx: 15.96,
    ry: 16.89,
    transform: "translate(-314.59 -73.51) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-125",
    cx: 408.28,
    cy: 206.37,
    rx: 15.49,
    ry: 16.4,
    transform: "translate(-314.59 -73.51) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-126",
    cx: 408.28,
    cy: 206.38,
    rx: 15.02,
    ry: 15.9,
    transform: "translate(-314.59 -73.5) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-127",
    cx: 408.28,
    cy: 206.37,
    rx: 14.55,
    ry: 15.4,
    transform: "translate(-314.59 -73.51) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M394.25,207.65c-.74-8.2,4.93-15.41,12.68-16.12s14.63,5.37,15.38,13.57-4.93,15.41-12.68,16.12S395,215.85,394.25,207.65Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-129",
    cx: 408.28,
    cy: 206.38,
    rx: 13.61,
    ry: 14.41,
    transform: "translate(-314.59 -73.52) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-130",
    cx: 408.28,
    cy: 206.37,
    rx: 13.15,
    ry: 13.91,
    transform: "translate(-314.59 -73.51) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M395.66,207.52c-.67-7.37,4.43-13.87,11.41-14.5s13.16,4.83,13.83,12.21-4.43,13.87-11.4,14.5S396.33,214.9,395.66,207.52Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M396.12,207.48c-.64-7.1,4.28-13.36,11-14s12.68,4.65,13.33,11.76-4.28,13.36-11,14S396.77,214.59,396.12,207.48Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M396.59,207.44c-.62-6.83,4.11-12.85,10.57-13.43s12.19,4.47,12.81,11.3-4.11,12.85-10.56,13.43S397.21,214.27,396.59,207.44Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M397.06,207.4c-.6-6.56,3.94-12.34,10.14-12.9s11.71,4.3,12.3,10.85-3.94,12.34-10.14,12.9S397.66,214,397.06,207.4Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M397.53,207.35c-.57-6.28,3.78-11.81,9.72-12.36s11.21,4.12,11.78,10.41-3.78,11.81-9.71,12.35S398.1,213.64,397.53,207.35Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-136",
    cx: 408.28,
    cy: 206.37,
    rx: 10.33,
    ry: 10.93,
    transform: "translate(-314.59 -73.51) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M398.46,207.27A10.17,10.17,0,0,1,407.34,196c5.42-.49,10.24,3.76,10.76,9.5s-3.45,10.79-8.87,11.29A10.16,10.16,0,0,1,398.46,207.27Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M398.93,207.23a9.4,9.4,0,1,1,10.25,9A9.68,9.68,0,0,1,398.93,207.23Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-139",
    cx: 408.28,
    cy: 206.38,
    rx: 8.92,
    ry: 9.44,
    transform: "translate(-314.59 -73.5) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M399.86,207.14a8.47,8.47,0,1,1,9.23,8.14A8.71,8.71,0,0,1,399.86,207.14Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-141",
    cx: 408.28,
    cy: 206.38,
    rx: 7.98,
    ry: 8.45,
    transform: "translate(-314.59 -73.52) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M400.8,207.06a7.52,7.52,0,1,1,8.2,7.23A7.73,7.73,0,0,1,400.8,207.06Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M401.27,207A7.05,7.05,0,1,1,409,213.8,7.25,7.25,0,0,1,401.27,207Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-144",
    cx: 408.28,
    cy: 206.38,
    rx: 6.57,
    ry: 6.96,
    transform: "translate(-314.6 -73.5) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M402.2,206.93a6.12,6.12,0,1,1,6.67,5.88A6.3,6.3,0,0,1,402.2,206.93Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M402.67,206.89a5.64,5.64,0,1,1,6.15,5.42A5.8,5.8,0,0,1,402.67,206.89Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M403.14,206.84a5.17,5.17,0,1,1,5.64,5A5.32,5.32,0,0,1,403.14,206.84Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-147",
    cx: 408.28,
    cy: 206.38,
    rx: 4.69,
    ry: 4.97,
    transform: "translate(-314.61 -73.47) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M404.07,206.76a4.23,4.23,0,1,1,4.62,4.07A4.36,4.36,0,0,1,404.07,206.76Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M404.54,206.72a3.76,3.76,0,1,1,4.1,3.61A3.86,3.86,0,0,1,404.54,206.72Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M405,206.67a3.29,3.29,0,1,1,3.59,3.17A3.39,3.39,0,0,1,405,206.67Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M405.48,206.63a2.82,2.82,0,1,1,3.07,2.71A2.89,2.89,0,0,1,405.48,206.63Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M405.94,206.59a2.35,2.35,0,1,1,2.57,2.26A2.42,2.42,0,0,1,405.94,206.59Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M406.41,206.55a1.88,1.88,0,1,1,2,1.8A1.93,1.93,0,0,1,406.41,206.55Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M406.88,206.5a1.41,1.41,0,1,1,1.54,1.36A1.44,1.44,0,0,1,406.88,206.5Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M407.35,206.46a1,1,0,0,1,.84-1.07,1,1,0,1,1-.84,1.07Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M407.81,206.42a.47.47,0,1,1,.52.45A.5.5,0,0,1,407.81,206.42Z",
    transform: "translate(-297.58 -111.34)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "74.55 65.61 66.92 48.51 88.59 34.06 91.74 28.64 92.17 28.89 88.91 34.45 67.55 48.69 75.01 65.41 74.55 65.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "17.36 145.63 17.32 145.13 39.85 143.08 41.44 122 53.27 115.77 53.5 116.21 41.92 122.31 40.32 143.54 40.1 143.56 17.36 145.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "241.65 81.31 255.6 80.04 273.43 92.24 254.99 82.82 241.34 84.05 241.65 81.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "189.24 103.24 188.97 106.8 168.68 116.37 188.34 106.34 187.29 101.96 189.24 103.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "146.65 52.39 151.55 57.59 169.51 56.59 150.39 58.84 144.38 55.04 146.65 52.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "92.84 29.05 89.34 34.41 78.37 41.18 88.13 34.14 91.04 28.47 92.84 29.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "55.95 118.07 41.68 122.16 52.32 114.99 55.95 118.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M373.34,177,366,160.19l21.55-14.25s-18.45,12.41-19,14.64S373.34,177,373.34,177Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M314.61,256.37l22.22-3,1.72-20.77s-1.36,18.59-3.74,19.88S314.61,256.37,314.61,256.37Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M475.64,251.61l-8.57-23.55L487,218.42s-16.52,7.82-17.8,9.84S475.64,251.61,475.64,251.61Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M447.61,170.58l27.79-2.89-2.46,25s2.17-22.15.47-23.15S447.61,170.58,447.61,170.58Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M552.9,190.49l18,12,15.57-15s-13,12.89-15.75,13S552.9,190.49,552.9,190.49Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "169.49 116.72 171.45 117.43 172.19 121.96 171.65 122.01 169.49 116.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "273.33 91.13 273.14 89.08 277.54 87.07 273.33 91.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "39.26 142.05 37.23 141.16 31.83 142.72 39.26 142.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "68.4 48.85 70.96 49.82 72.17 55.1 68.4 48.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M350.86,242.64s10.18,6.13,22.46,4,38.23-33.81,38.23-33.81-25.39,30.1-39,32.46S350.86,242.64,350.86,242.64Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M488.93,135.92s9.77-5.63,27.52-6.31C516.45,129.61,504.86,125.48,488.93,135.92Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M507.61,229.86A31,31,0,0,0,525,232.74c9.88-1.24,16.53-9,16.53-9S527.31,236.83,507.61,229.86Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M332.91,152.55s15.26-8.59,30.37-9.41,22.43,2.34,22.43,2.34S361.43,134.32,332.91,152.55Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M511.5,222.73s7-.2,12.29-4.23L525,232.74s-8.65.59-13.3-1.25Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M532.58,169.4s8.3,1,13.88,6.83c0,0-4.87-8.81-19.8-13A50.84,50.84,0,0,1,532.58,169.4Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M346.06,182.54s-11.25,6.09-14.43,23.13c0,0,1.29-7.48,9.44-13.55C341.07,192.12,344.73,183.77,346.06,182.54Z",
    transform: "translate(-297.58 -111.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M382.5,241.92l23.94,22.42a378.75,378.75,0,0,0,37.26-37.59c17.71-20.85,38.88-45.05,46.19-50.84l-19.67-27.32c-12.18,11.09-34.82,33.66-61.11,66.76C391.87,237.05,382.5,241.92,382.5,241.92Z",
    transform: "translate(-297.58 -111.34)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDixiLogoNew);
export default __webpack_public_path__ + "static/media/dixi-logo-new.da426565cbf3fd664cbebb1fdc5faad3.svg";
export { ForwardRef as ReactComponent };